import React, { useCallback } from "react";
import { Accordion, AccordionItem } from "@commonComponents/accordion";
import { ActorDetailForm,ActorDetailHeader } from "@EUForms/parties";
import { partiesLabel } from "../../util/partiesLabel";
import RepeatableContainer from "@containers/repeatableContainer";
import ConsignorDetail from "./consignorDetail";
import ExporterDetail from "./exporterDetail";
import ConsigneeDetail from "./consigneeDetail";
import AgentDetail from "./agentDetail";
import DeclarantDetail from "./declarantDetail";
import CarrierDetail from "./carrierDetail";
import useValidatePartiesAtShipment from "../../hooks/useValidatePartiesAtShipment";


const PartiesContainer=({translate,countryList,repeatableValidationMethods,...rest})=> {

  const {validateError,updateErrors} = repeatableValidationMethods
  
  const {maxAllowedConsigneeList, maxAllowedConsignorsList } = useValidatePartiesAtShipment()
       
  return (
    <Accordion  translate={translate}>
   <AccordionItem id={partiesLabel.consignor.tableName}  title={(props)=>(
           <ActorDetailHeader  {...props} translate={translate} {...partiesLabel.consignor} ></ActorDetailHeader>)}>
             <RepeatableContainer 
            {...rest}
            tableName={partiesLabel.consignor.tableName}
            actionType="PARTIES"
            reducerName="actorReducer"
            title={''}
            errorTitle={partiesLabel.consignor.title}
            translate={translate}
            validateError={validateError}
            updateErrors={updateErrors}
            maxRowsAllowed={maxAllowedConsignorsList}
            renderForm={(params)=><ConsignorDetail 
                {...params}
                renderForm={(props)=><ActorDetailForm countryList={countryList} displayState={true} {...props} />}
                />
            }
          />
        
   </AccordionItem>
   <AccordionItem id={partiesLabel.exporter.tableName}   title={(props)=>(<ActorDetailHeader  {...props} translate={translate}  {...partiesLabel.exporter} ></ActorDetailHeader>)}>
   <RepeatableContainer 
            {...rest}
            tableName={partiesLabel.exporter.tableName}
            actionType="PARTIES"
            reducerName="actorReducer"
            title={''}
            errorTitle={partiesLabel.exporter.title}
            translate={translate}
            validateError={validateError}
            updateErrors={updateErrors}
            maxRowsAllowed={1}
            renderForm={(params)=><ExporterDetail 
                {...params}
                renderForm={(props)=><ActorDetailForm countryList={countryList} displayState={true}  {...props} />}
                />
            }
          />
   </AccordionItem>
   <AccordionItem id={partiesLabel.consignee.tableName}  title={(props)=>(<ActorDetailHeader  {...props} translate={translate} {...partiesLabel.consignee} ></ActorDetailHeader>)}>
   <RepeatableContainer 
            {...rest}
            tableName={partiesLabel.consignee.tableName}
            actionType="PARTIES"
            reducerName="actorReducer"
            title={''}
            errorTitle={partiesLabel.consignee.title}
            translate={translate}
            validateError={validateError}
            updateErrors={updateErrors}
            maxRowsAllowed={maxAllowedConsigneeList}
            renderForm={(params)=><ConsigneeDetail 
                {...params}
                renderForm={(props)=><ActorDetailForm countryList={countryList} displayState={true} {...props} />}
                />
            }
          />
   </AccordionItem>
   <AccordionItem id={partiesLabel.representative.tableName}  title={(props)=>(<ActorDetailHeader  {...props} translate={translate} {...partiesLabel.representative} ></ActorDetailHeader>)}>
          
   <RepeatableContainer 
            {...rest}
            tableName={partiesLabel.representative.tableName}
            actionType="PARTIES"
            reducerName="actorReducer"
            title={''}
            errorTitle={partiesLabel.representative.title}
            translate={translate}
            validateError={validateError}
            updateErrors={updateErrors}
            maxRowsAllowed={1}
            renderForm={(params)=><AgentDetail 
                {...params}
                renderForm={(props)=><ActorDetailForm countryList={countryList} displayState={true}  {...props} />}
                />
            }
          />
        
   </AccordionItem>
   <AccordionItem id={partiesLabel.declarant.tableName}  title={(props)=>(<ActorDetailHeader  {...props} translate={translate} {...partiesLabel.declarant} ></ActorDetailHeader>)}>
   <RepeatableContainer 
            {...rest}
            tableName={partiesLabel.declarant.tableName}
            actionType="PARTIES"
            reducerName="actorReducer"
            title={''}
            errorTitle={partiesLabel.declarant.title}
            translate={translate}
            validateError={validateError}
            updateErrors={updateErrors}
            maxRowsAllowed={1}
            renderForm={(params)=><DeclarantDetail 
                {...params}
                renderForm={(props)=><ActorDetailForm countryList={countryList}  displayState={true}  {...props} />}
                />
            }
          />
   </AccordionItem>
   <AccordionItem id={partiesLabel.carrier.tableName}  title={(props)=>(<ActorDetailHeader  {...props} translate={translate} {...partiesLabel.carrier} ></ActorDetailHeader>)}>
   <RepeatableContainer 
            {...rest}
            tableName={partiesLabel.carrier.tableName}
            actionType="PARTIES"
            reducerName="actorReducer"
            title={''}
            errorTitle={partiesLabel.carrier.title}
            translate={translate}
            validateError={validateError}
            updateErrors={updateErrors}
            maxRowsAllowed={1}
            renderForm={(params)=><CarrierDetail 
                {...params}
                renderForm={(props)=><ActorDetailForm countryList={countryList} displayState={true}  {...props} />}
                />
            }
          />
        
   </AccordionItem>
   </Accordion>
  
  );
}

export default React.memo(PartiesContainer)
